// Package imports:
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
// Bugsnag imports:
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact, { BugsnagErrorBoundary } from '@bugsnag/plugin-react'
// Component imports:
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
// Service imports:
import reducers from './redux-store/reducers';
import { error } from 'console';
import { config as fontAwesomeConfig } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';

// Bugsnag and ErrorBoundary is only active if in production/staging.
let PossibleErrorBoundary: typeof Fragment | BugsnagErrorBoundary = Fragment;
if (process.env.REACT_APP_NODE_ENV === 'production' || process.env.REACT_APP_NODE_ENV === 'staging') {
  // Bugsnag integration.
  Bugsnag.start({
    apiKey: '041ecef44688ce57c831ba6991215a58',
    plugins: [new BugsnagPluginReact()],
    releaseStage: process.env.REACT_APP_NODE_ENV
  });
  
  PossibleErrorBoundary = Bugsnag?.getPlugin('react')?.createErrorBoundary(React) || Fragment;
}

// Prevent FontAwesome from injecting CSS automatically, to comply with CSP.
fontAwesomeConfig.autoAddCss = false;

// @ts-ignore
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = configureStore({
    reducer: reducers,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

const rootElement = document.getElementById('root');
if(!rootElement) throw new Error('Failed to find root element');
const root = ReactDOM.createRoot(rootElement);

root.render(
    <React.StrictMode>
        <PossibleErrorBoundary>
            <Provider store={store}>
                <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
                    <App/>
                </Router>
            </Provider>
        </PossibleErrorBoundary>
    </React.StrictMode>
)

// ReactDOM.render(
//     <React.StrictMode>
//         <PossibleErrorBoundary>
//             <Provider store={store}>
//                 <Router>
//                     <App />
//                 </Router>
//             </Provider>
//         </PossibleErrorBoundary>
//     </React.StrictMode>,
//     document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
